import EnumDto from 'modules/base/dto/enum/EnumDto';
import NamedDto from 'modules/base/dto/NamedDto';
import nBossConnection from 'modules/base/service/nBossConnection';

class PiAfEventReaderService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'piAfEventReaderControl';
	}

	/** @return {Promise<NamedDto[]>} */
	getListSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getListSelection`)
				.then(response => resolve(response.data != null ? response.data.map(item => new NamedDto().setup(item)) : []))
				.catch(reject);
		});
	}

	/** @return {Promise<EnumDto[]>} */
	getListSelectionEnum() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getListSelection`)
				.then(response => resolve(response.data != null ? response.data.map(item => new EnumDto().setup({ label: item.name, value: item.name })) : []))
				.catch(reject);
		});
	}

	get(id, query) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/get`, { id, query })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	createMeasurement(measurementName, readerName) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/createMeasurement`, { measurementName, readerName })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new PiAfEventReaderService();
